module.exports = __webpack_public_path__ + "static/assets/05eaa5ac64662148b01e96f636a1d7b4.png";